import React, { useEffect } from 'react';
import RateCalculator from '../components/RateCalculator';

export const GetQuotePage = () => {
  useEffect(() => {
    // Scroll to the form top if hash is present
    if (window.location.hash === '#quote-form-top') {
      const element = document.getElementById('quote-form-top');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, []);

  return (
    <div className="py-10" data-testid="get-quote-page">
      <div className="max-w-7xl mx-auto px-4">
        <div id="quote-form-top">
          <h1 className="text-3xl font-bold mb-4 text-center">Get Instant Shipping Rates</h1>
          <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">
            Calculate your shipping rate instantly. Get accurate pricing in seconds.
          </p>
        </div>

        {/* Rate Calculator */}
        <RateCalculator />
      </div>
    </div>
  );
};

export default GetQuotePage;